import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  wrapper: {
    base: {
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: theme.settings.spacing.large,
      ...theme.settings.focusWithinStyles,
    },

    toggle: {
      width: '40px',
    },

    normal: {
      cursor: 'pointer',
    },

    block: {
      display: 'flex',
      marginRight: 0,
      marginBottom: theme.settings.spacing.small,
    },

    flush: {
      marginRight: 0,
      marginBottom: 0,
    },
  },

  input: {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      opacity: 0,
      cursor: 'pointer',
    },

    disabled: {
      cursor: 'default',
    },
  },

  radioFillPath: {
    normal: {
      fill: '#298bff',
    },

    hovered: {
      fill: '#1d70d2',
    },

    disabled: {
      fill: 'rgba(153, 153, 153, 0.4)',
    },
  },
  svg: {
    base: {
      flexShrink: 0,
    },
    withLabel: {
      marginRight: theme.settings.spacing.small,
    },
  },
})
